var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"mock"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"loading"},[_vm._v("{ 404 }")]),_vm._v(" "),_c('div',[_vm._v("您访问的页面不存在")]),_vm._v(" "),_c('div',{staticClass:"back",on:{"click":_vm.goback}},[_vm._v(" 请返回")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-cbd9eb04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/page404.vue
// module id = null
// module chunks = 